import { useState } from 'react';
import {
  getLocalStorage,
  LocalStorageKeys,
  setLocalStorage,
} from '../../localStorage/localStorage';

export interface FavoriteIconHookProps {
  id: string;
}

export const cleanOldFavoriteInLocalStorage = (events: string[]) => {
  const value = getFavorites()?.filter((value: string) => events?.includes(value));
  setLocalStorage(LocalStorageKeys.favoriteEvents, JSON.stringify(value));
};

export const getFavorites = () => {
  const item = getLocalStorage(LocalStorageKeys.favoriteEvents);
  return item ? JSON.parse(item) : [];
};

const useFavoriteIconHook = ({ id }: FavoriteIconHookProps) => {
  const [isFavorite, setIsFavorite] = useState<boolean>(
    () => getFavorites()?.findIndex((favorite: string) => favorite === id) !== -1,
  );

  const setIsFavoriteValue: any = (value: boolean | ((val: boolean) => boolean)) => {
    const valueToStore = value instanceof Function ? value(isFavorite) : value;
    setIsFavorite(valueToStore);
    if (valueToStore) {
      setLocalStorage(LocalStorageKeys.favoriteEvents, JSON.stringify(getFavorites()?.concat(id)));
    } else {
      setLocalStorage(
        LocalStorageKeys.favoriteEvents,
        JSON.stringify(getFavorites()?.filter((value: string) => value !== id)),
      );
    }
  };

  return [isFavorite, setIsFavoriteValue];
};

export default useFavoriteIconHook;
